// Factures page shell: year picker, top badges, then the composed panels.
// All state lives in useFacturesState (useFacturesContext.tsx); each topic
// has its own file: MensualitatsPanel, SummaryCards, UnitatDetail (classic
// caps/unitat view), UnitatDrawer (money view), MovimentsPanel, EntryItem,
// DespesaForm, CapNameInput.

import { useParams } from 'react-router-dom';

import { useFactures, FacturesProvider } from './useFacturesContext';
import { currentSchoolYear, fmtEUR } from './facturesTypes';
import { MensualitatsPanel } from './MensualitatsPanel';
import { SummaryCards } from './SummaryCards';
import { UnitatDetail } from './UnitatDetail';
import { UnitatDrawer } from './UnitatDrawer';
import { MovimentsPanel } from './MovimentsPanel';
import {
	Container,
	Row,
	TopBadge,
	TopRow,
	Title,
	YearSelect,
} from './Factures.styles';
import { ErrorMessage, Label } from '../Shared/FormStyles';

const years = (() => {
	const y = parseInt(currentSchoolYear().substring(0, 4));
	const list: string[] = [];
	for (let i = y; i >= y - 6; i--) list.push(`${i}-${i + 1}`);
	return list;
})();

const FacturesInner = () => {
	const fac = useFactures();
	return (
		<Container>
			<Title>Factures</Title>
			<Row>
				<Label>Any escolar:</Label>
				<YearSelect value={fac.year} onChange={(e) => fac.setYear(e.target.value)}>
					{years.map((y) => (
						<option key={y} value={y}>
							{y}
						</option>
					))}
				</YearSelect>
			</Row>
			{fac.error && <ErrorMessage>{fac.error}</ErrorMessage>}
			{fac.canSeeGlobal && (
				<TopRow>
					{fac.money && fac.mensualMissing.length > 0 && (
						<TopBadge $alert>
							⚠ {fac.mensualMissing.length}{' '}
							{fac.mensualMissing.length === 1
								? 'mensualitat pendent'
								: 'mensualitats pendents'}
						</TopBadge>
					)}
					{fac.globalSummary &&
						fac.globalSummary.byCap.length > 0 &&
						fac.globalSummary.totalOwedCents !== 0 && (
							<TopBadge>
								{fac.globalSummary.totalOwedCents > 0
									? `💰 la Tresoreria deu ${fmtEUR(fac.globalSummary.totalOwedCents)}`
									: `🧾 pendent de tornar: ${fmtEUR(Math.abs(fac.globalSummary.totalOwedCents))}`}
							</TopBadge>
						)}
				</TopRow>
			)}
			{/* unitat accounts: the single card would just duplicate the
			    unitat's own detail below — skip the grid entirely */}
			{fac.money && !fac.ownUnitat && <MensualitatsPanel />}
			{!fac.ownUnitat && (
				<SummaryCards />
			)}
			{fac.selected &&
				(!fac.money || fac.ownUnitat) && (
					<UnitatDetail />
				)}
			{fac.money && !fac.ownUnitat && fac.selected && <UnitatDrawer />}
			{fac.money && !fac.selected && <MovimentsPanel />}
		</Container>
	);
};

const Factures = () => {
	const params = useParams<{ schoolYear?: string }>();
	return (
		<FacturesProvider initialYear={params.schoolYear}>
			<FacturesInner />
		</FacturesProvider>
	);
};

export default Factures;
